import React, { useState, useEffect, useRef } from "react"
import { Tag, Table, Space, Button, Modal, Form, Input, InputNumber, message, Row, Col } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
const { Search } = Input
import { dictApi } from '@api/newApi'
import { toolMouseTip } from '@utils/common'
import './index.scss'
const Dict = (props) => {
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [dictCateList, setDictCateList] = useState([])
  const [dictList, setDictList] = useState([])
  const [dictModal, setDictModal] = useState(false)
  const [classifyId, setClassifyId] = useState()
  const [dictLoading, setDictLoading] = useState(false)
  const [dictTotal, setDictTotal] = useState(0)
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10
  })
  const [dictSearchParams, setDictSearchParams] = useState({
    pageNum: 1,
    pageSize: 10
  })
  const [searchDisName, setSearchDisName] = useState()
  const dictSearchParamsRef = useRef()
  const [dictCateModal, setDictCateModal] = useState(false)
  const [dictCateForm] = Form.useForm()
  const [editDictId, setEditDictId] = useState()
  const [dictCateType, setDictCateType] = useState('add')
  const [dictAddEditModal, setDictAddEditModal] = useState(false)
  const [dictAddEditType, setDictAddEditType] = useState('add')
  const [dictAddEditForm] = Form.useForm()
  const [dictId, setDictId] = useState()
  useEffect(() => {
    dictSearchParamsRef.current = dictSearchParams
    if (classifyId) {
      getDictList()
    }
  }, [dictSearchParams])

  useEffect(() => {
    getClsfy()
  }, [searchParams])


  const getClsfy = () => {
    setLoading(true)
    dictApi.selectAllClassify(searchParams).then(res => {
      setLoading(false)
      if (res.status === '0' && res.data) {
        setDictCateList(res.data)
        setTotal(res.data?.total)
      }
    })
  }

  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  }

  const showInfo = (record) => {
    setClassifyId(record.id)
    setDictModal(true)
    getDictList(record.id)
  }

  const getDictList = (id) => {
    setDictLoading(true)
    const clsId = id ? id : classifyId
    dictApi.selectByPage({ classifyId: clsId, ...dictSearchParamsRef.current }).then(res => {
      setDictLoading(false)
      if (res.status === '0') {
        setDictList(res.data?.data)
        setDictTotal(res.data?.total)
      }
    })
  }

  const search = (text) => {
    let params = {
      classifyName: text,
      pageNum: 1,
      pageSize: 10
    }
    setSearchParams(params)
  }


  // 删除分类
  const delDictCate = (id) => {
    Modal.confirm({
      title: '删除字典分类',
      icon: <ExclamationCircleOutlined />,
      content: '此操作将永久删除该分类, 是否继续?',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        const res = await dictApi.delClassify({ id })
        if (res.status !== '0') return
        message.success('删除成功')
        getClsfy()
      }
    })
  }

  // 删除字典
  const delDict = (id) => {
    Modal.confirm({
      title: '删除字典',
      icon: <ExclamationCircleOutlined />,
      content: '此操作将永久删除该字典, 是否继续?',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        const res = await dictApi.dictDel({ id })
        if (res.status !== '0') return
        message.success('删除成功')
        getDictList()
      }
    })
  }

  // 编辑分类弹窗
  const editDict = (record) => {
    setEditDictId(record.id)
    setDictCateType('edit')
    dictCateForm.setFieldsValue({
      key: record.key,
      name: record.name
    })
    setDictCateModal(true)
  }

  // 编辑字典弹窗
  const showDictAddEditModal = (record) => {
    setDictAddEditType('edit')
    dictAddEditForm.setFieldsValue({
      disName: record.disName,
      value: record.value,
      orderIdx: record.orderIdx
    })
    setDictId(record.id)
    setDictAddEditModal(true)
  }

  const changeDictSize = (pagination) => {
    let params = {
      ...dictSearchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setDictSearchParams(params)
  }

  const submitDictCateModal = () => {
    dictCateForm.validateFields().then(values => {
      if (!values) return
      if ( dictCateType === 'add' ) {
        dictApi.insertClassify(values).then(res => {
          if (res.status !== '0') return
          message.success('新增成功')
          closeDictCateModal()
          getClsfy()
        })
      } else {
        dictApi.ModifyClassify({...values, id: editDictId}).then(res => {
          if (res.status !== '0') return
          message.success('修改成功')
          closeDictCateModal()
          getClsfy()
        })
      }
    })
  }

  const closeDictCateModal = () => {
    dictCateForm.resetFields()
    setDictCateModal(false)
  }

  const closeDictAddEditModal = () => {
    dictAddEditForm.resetFields()
    setDictAddEditModal(false)
  }

  const onSearch = (text) => {
    let params = {
      ...dictSearchParams,
      disName: text
    }
    setDictSearchParams(params)
  }

  const closeDictModal = () => {
    setDictModal(false)
    setSearchDisName('')
    let params = {
      pageNum: 1,
      pageSize: 10
    }
    setDictSearchParams(params)
  }

  const submitDictAddEditModal = () => {
    dictAddEditForm.validateFields().then(values => {
      if ( !values ) return
      const params = { ...values, classifyId }
      if ( dictAddEditType === 'add' ) {
        dictApi.dictCreate(params).then(res => {
          if ( res.status !== '0' ) return
          message.success('新增成功')
          closeDictAddEditModal()
          getDictList()
        })
      } else {
        dictApi.dictUpdate({...params, id: dictId}).then(res => {
          if ( res.status !== '0' ) return
          message.success('修改成功')
          closeDictAddEditModal()
          getDictList()
        })
      }
    })
  }

  const columns = [
    {
      title: '字典分类',
      dataIndex: 'name',
      align: 'center',
      key: 'name',
    },
    {
      title: 'key',
      dataIndex: 'key',
      align: 'center',
      key: 'key',
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      key: 'action',
      render: (_, record) => {
        return (
          <Space size="middle">
            {/* <Tag onClick={() => editDict(record)} color="#2db7f5">编辑</Tag> */}
            {/* <Tag onClick={() => delDictCate(record.id)} color="#f50">删除</Tag> */}
            <Tag onClick={() => showInfo(record)} color="#2db7f5">详情</Tag>
          </Space>
        )
      }
    }
  ]

  const dictColumns = [
    {
      title: '字典分类',
      dataIndex: 'classifyName',
      align: 'center',
      key: 'classifyName',
    },
    {
      title: '字典名称',
      dataIndex: 'disName',
      align: 'center',
      key: 'disName',
    },
    {
      title: '字典值',
      dataIndex: 'value',
      align: 'center',
      key: 'value',
      render: _ => toolMouseTip(_, 20)
    },
    {
      title: '排序',
      dataIndex: 'orderIdx',
      align: 'center',
      key: 'orderIdx'
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      key: 'action',
      fixed: 'right',
      width: 120,
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tag onClick={() => showDictAddEditModal(record)} color="#2db7f5">编辑</Tag>
            <Tag
              onClick={ () => delDict(record.id) }
              color="#f50">删除</Tag>
          </Space>
        )
      }
    }
  ]


  return (
    <div className="dict-container">
      <Row gutter={20}>
        <Col span={12}>
          <Search placeholder="请输入分类名称" onSearch={search} enterButton />
        </Col>
        <Col span={4}>
          {/* <Button onClick={() => (setDictCateModal(true), setDictCateType('add')) } type="primary" size="mini">新增</Button> */}
        </Col>
      </Row>
      <Table
        className='Table'
        scroll={{ x: columns.length * 200 }}
        columns={columns}
        dataSource={dictCateList}
        rowKey={record => record.id}
        pagination={{
          current: searchParams.pageNum,
          pageSize: searchParams.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: total => `共${total}条数据`,
          total: total
        }}
        onChange={handleTableChange}
        loading={loading}
      />
      <Modal
        width={900}
        title="字典管理"
        open={dictModal}
        onOk={closeDictModal}
        onCancel={closeDictModal}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Search placeholder="请输入字典名称" value={searchDisName} onSearch={onSearch} onChange={(e) => setSearchDisName(e.target.value)} enterButton />
          </Col>
          <Col span={4}>
          <Button onClick={() => (setDictAddEditType('add'),setDictAddEditModal(true))} type="primary" size="mini">新增</Button>
          </Col>
        </Row>
        <Table
          className='Table'
          scroll={{ x: dictColumns.length * 200 }}
          columns={dictColumns}
          dataSource={dictList}
          rowKey={record => record.id}
          pagination={{
            current: dictSearchParams.pageNum,
            pageSize: dictSearchParams.pageSize,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: dictTotal => `共${dictTotal}条数据`,
            total: dictTotal
          }}
          onChange={changeDictSize}
          loading={dictLoading}
        />
      </Modal>
      {/* 新增字典分类 */}
      <Modal
        title={dictCateType === 'add' ? '新增字典分类' : '编辑字典分类'}
        open={dictCateModal}
        onCancel={closeDictCateModal}
        onOk={submitDictCateModal}
      >
        <Form
          name="basic"
          form={dictCateForm}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          autoComplete="off"
        >
          <Form.Item label='分类名称' name="name" rules={[{ required: true, message: '请输入分类名称' }]}>
            <Input placeholder="请输入分类名称" />
          </Form.Item>
          <Form.Item label='分类key' name="key" rules={[{ required: true, message: '请输入分类key' }]}>
            <Input placeholder="请输入分类key" />
          </Form.Item>
        </Form>
      </Modal>
      {/* /新增字典分类 */}

      {/* 新增字典 */}
      <Modal
        title={ dictAddEditType === 'add' ? '新增字典' : '编辑字典' }
        open={dictAddEditModal}
        onCancel={closeDictAddEditModal}
        onOk={submitDictAddEditModal}
      >
        <Form
          name="basic"
          form={dictAddEditForm}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          autoComplete="off"
        >
          <Form.Item label='字典名称' name="disName" rules={[{ required: true, message: '请输入字典名称' }]}>
            <Input placeholder="请输入字典名称" />
          </Form.Item>
          <Form.Item label='字典值' name="value" rules={[{ required: true, message: '请输入字典值' }]}>
            <Input placeholder="请输入字典值" />
          </Form.Item>
          <Form.Item label='字典排序' name="orderIdx" rules={[{ required: true, message: '请输入字典排序' }]}>
            <InputNumber min={0} />
          </Form.Item>
        </Form>
      </Modal>
      {/* /新增字典 */}
    </div>
  )
}

export default Dict
